import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import queryString from 'query-string';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Header from '../../components/Header';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import InvoiceGochiHistoryTable from '../organisms/InvoiceGochiHistoryTable';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getInvoiceHistoryShop } from '../../actions/Shop';
import { getAccounts } from '../../actions/Accounts';
import InvoiceHistoryShopButton from '../../components/atoms/InvoiceHistoryShopButton';

const styles = theme => ({
  root: {
    backgroundColor: '#F7F7F7',
    flexGrow: 1,
    width: '100%',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 375,
      backgroundColor: '#F7F7F7',
      margin: '0 auto'
    }
  },
  rootClassic: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  mainContent: {
    padding: 15
  },
  pageTitileDiv: {
    textAlign: 'left',
    marginBottom: 10
  },
  mainPaper: {
    position: 'relative'
  },
  fs24: {
    fontSize: '24px'
  },
  searchForm: {
    padding: '10px 20px 20px 20px',
    display: 'block',
    height: '68px'
  },
  buttonRight: {
    textAlign: 'right',
    float: 'right'
  },
  buttonLeft: {
    textAlign: 'left',
    float: 'left'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getInvoiceHistoryShop,
          getAccounts
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openModal', 'updateOpenModal', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('listInvoice', 'setListInvoice', []),
  withState('perPage', 'setPerPage', 10),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangePage: props => (event, page, limit) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 100;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }
      const searchKey = {
        page,
        limit: limit || limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions
        .getInvoiceHistoryShop(searchKey)
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          props.updateOpenTable(true);
        })
        .catch(() => {
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
        });
      props.setPage(page);
    },
    loadHistoryInvoiceData: props => page => {
      setTimeout(() => {
        props.updateLoading(true);
        props.updateOpenProgress(true);
        const searchKey = {
          limit: 100,
          page
        };
        props.actions
          .getInvoiceHistoryShop(searchKey)
          .then(data => {
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            props.updateOpenProgress(false);
            props.updateLoading(false);

            let list = [];
            if (page > 1) {
              list = props.listInvoice;
            } else {
              list = [];
            }

            if (data.type === 'GET_INVOICE_HISTORY_SHOP_SUCCESS') {
              if (data.payload.list) {
                data.payload.list.map(gochi => {
                  return list.push(gochi);
                });
                props.setListInvoice(list);
              }
            }
          })
          .catch(error => {
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
            console.log('error', error);
          });
      }, 100);
    }
  }),
  lifecycle({
    async componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' });
    },
    componentUnmount() {
      const list = [{ foo: undefined }];
      this.props.setListInvoice(list);
      console.log(this.props.listInvoice);
    }
  })
);

const Main = enhance(
  ({
    classes,
    handleChangePage,
    account,
    updateOpenDrawer,
    loading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    handleRedirect,
    loadHistoryInvoiceData,
    setListInvoice,
    page
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isDeveloper =
      typeof account !== 'undefined' && account.role === 'DEVELOPER';
    const roles = {
      isShop,
      isGroup,
      isSecretariat,
      isDeveloper
    };

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limit = 100;
    if (rowsPerPage) {
      limit = rowsPerPage.textContent;
    }

    let searchKey = {
      limit
    };

    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;

    const para = queryString.parse(window.location.search);
    // check if is account shop
    if (!isShop && !isReleased && !para.notify) {
      console.log('isShop', isShop);
      console.log('isReleased', isReleased);
      console.log('para.notify', para.notify);
      handleRedirect('/shops');
    }

    const searchAction = () => {
      setListInvoice([]);

      searchKey = {
        ...searchKey
      };
      loadHistoryInvoiceData(1, true);
    };

    useEffect(() => {
      searchAction();
    }, []);

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    return (
      <>
        <div className={classes.rootClassic}>
          <Header
            onMenuClick={() => {
              updateOpenDrawer(true);
            }}
          />

          <div className={classes.mainContent}>
            <div className={classes.pageTitileDiv}>
              <Typography color="textPrimary" className={classes.fs24}>
                請求確定履歴
              </Typography>
            </div>
            <Paper className={classes.mainPaper} elevation={1}>
              <div className={classes.searchForm}>
                <div className={classes.boxLeft}>
                  <div className={classes.buttonRight}>
                    <InvoiceHistoryShopButton
                      onClickAction={() => handleRedirect('invoice_shop')}
                      message="請求情報管理画面へ戻る"
                    />
                  </div>
                </div>
              </div>
              <InvoiceGochiHistoryTable
                isShop
                roles={roles}
                page={page}
                handleChangePage={handleChangePage}
                selectedPage={page}
              />
            </Paper>
            <ProgressDialog
              openProgress={openProgress}
              progressOkAction={progressOkAction}
              loading={loading}
              resultMessage={resultMessage}
            />
          </div>
        </div>
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
